var isPrototypeOf = require('../../internals/object-is-prototype-of');
var method = require('../function/virtual/bind');

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (isPrototypeOf(FunctionPrototype, it) && own === FunctionPrototype.bind) ? method : own;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/instance/bind.js
// module id = 517
// module chunks = 0 1